import React, { useContext, useState, useRef } from 'react';
import { useMutation } from '@apollo/client';
import {
  Text,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react';
import get from 'lodash/get';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import UserContext from '../../../contexts/UserContext';
import SpinnerContext from '../../../contexts/SpinnerContext';
import Input from '../../../components/Input';
import Select from '../../../components/Select';
import { CREATE_STRIPE_CUSTOMER } from '../query';
import { useCustomToast } from '../../../hooks/useCustomToast';

const CreateStripeCustomerSchema = Yup.object().shape({
  comment: Yup.string().required('Warum möchtest Du den Stripe Customer erstellen?'),
});

export const CreateStripeCustomer = ({ userId, refetch }) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const onAlertClose = () => setAlertOpen(false);
  const cancelRef = useRef();

  const { user: internalUser } = useContext(UserContext);
  const { toggleSpinner } = useContext(SpinnerContext);
  const [createStripeCustomerMutation] = useMutation(CREATE_STRIPE_CUSTOMER);
  const toast = useCustomToast();

  const handleCreateStripeCustomer = async () => {
    try {
      toggleSpinner(true);
      const {
        data: { createStripeCustomer },
      } = await createStripeCustomerMutation({
        variables: {
          userId,
          comment: 'Stripe Customer erstellt',
          internalUser: internalUser.id,
        },
      });
      await refetch();
      toast({
        title: 'Erfolg!',
        description: 'Der Stripe Customer wurde erstellt.',
        status: 'success',
      });
      setAlertOpen(false);
    } catch (error) {
      console.log(error);
      toast({
        description: get(error, 'graphQLErrors.0.message', 'Ein Fehler ist aufgetreten!'),
        status: 'error',
      });
    }
    toggleSpinner(false);
  };

  return (
    <>
      <Button variant="outline" colorScheme="brand" size="xs" onClick={() => setAlertOpen(true)}>
        Booker PayMethods erstellen
      </Button>

      <AlertDialog isOpen={alertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose}>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <Formik initialValues={{ comment: '' }} validationSchema={CreateStripeCustomerSchema} onSubmit={handleCreateStripeCustomer}>
            <Form>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Bist du sicher, dass du einen neuen Stripe Customer für diesen User erstellen möchtest?
              </AlertDialogHeader>

              <AlertDialogBody>
                <Input name="comment" label="Kommentar" />
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onAlertClose}>
                  Abbrechen
                </Button>
                <Button colorScheme="green" type="submit" ml={3}>
                  Stripe Customer erstellen
                </Button>
              </AlertDialogFooter>
            </Form>
          </Formik>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
